// extracted by mini-css-extract-plugin
module.exports = {"controlPanel":"ResultsView_controlPanel__J3R0v","dropdown":"ResultsView_dropdown__2UB4b"};